import { OneRosterFamilyDto } from '@families-link/shared';
import { FC, useCallback, useMemo } from 'react';
import { CoreTableActionsCell, CellAction } from '../../../_core/components/_ui/core-table';
import { EyeIcon } from '../../../_core/components/icons';
import { useTranslation } from 'react-i18next';
import { OneRosterFamiliesTableHandlers } from './oneroster-families-table.component';
export interface OneRosterFamilyTableProps extends OneRosterFamiliesTableHandlers {
    oneRosterFamily: OneRosterFamilyDto;
}

export const OneRosterFamiliesTableActions: FC<OneRosterFamilyTableProps> = (props) => {
    const { oneRosterFamily, onView } = props;
    const [t] = useTranslation();


    const handleViewFamily = useCallback(() => {
        if (!oneRosterFamily) {
            return;
        }

        onView?.(oneRosterFamily);
    }, [onView, oneRosterFamily]);

    const actions = useMemo<CellAction[]>(
        () => [
            {
                id: 'view',
                type: 'button',
                tooltipTitle: t('buttons.tooltips.full-details'),
                props: {
                    children: <EyeIcon sx={{ fontSize: 30 }} color="primary" />,
                    onClick: handleViewFamily,
                },
            },
        ],
        [handleViewFamily]
    );

    return <CoreTableActionsCell actions={actions} />;
};
